<template>

    <div class="listlayout"  id="rptListBox">

        <el-tabs v-model="activeName" type="card"  @tab-click='tabClick'>
            <el-tab-pane :label="$t('report.myreport')" name="rpt" :key="1">
                <el-tree ref="customTree"    :data="rptList"
                         :element-loading-text="$t('tips_data_loading_in_progress')" :props="nodeProps"
                           node-key="id" highlight-current   @node-click="handleNodeClick">
                </el-tree>
             </el-tab-pane>
            <el-tab-pane :label="$t('report.his')" name="his" :key="2">
                <el-tag  style="margin-top:2Px;margin-bottom:10Px;width:260px;height:30px;font-size: 14px;"> {{currentNode.label }}</el-tag>

                <el-tree ref="customTree2"    :data="importList"
                         :element-loading-text="$t('tips_data_loading_in_progress')" :props="hisProps"
                         node-key="i_id" highlight-current   @node-click="hisNodeClick">
                </el-tree>
            </el-tab-pane>

        </el-tabs>



    </div>


</template>
<script>
    import { mapGetters } from "vuex";
    import $ from 'jquery';
    import languages from '../lang/languages.js';
    export default {
        name: "getreportList",

        props: {
            importlist:Array,
            rptlist:Array,

        },
        data(){

            return {
                rptList:[],
                importList:[],
                activeName:"rpt",
                currentNode:{},
                nodeProps: { children:false, label: "label", isLeaf: "leaf" },
                hisProps: { children:false, label: "title",id:"i_id", isLeaf: "leaf" },
                focusObj:{},

            }
        },
        watch: {
            rptlist: {

                handler(n, o) {
                    this.rptList=n;

                },

            },
            importlist: {

                handler(n, o) {
                    this.importList=n;

                },

            },
        },

        mounted() {
            let lang=sessionStorage.getItem("vc_lang");
            this.$i18n.mergeLocaleMessage(lang, languages[lang]);
                this.$emit('loadRptList');
        },
        methods: {
            tabClick(tab,item) {
                  if(this.activeName=="rpt")  this.scrollToNode();
            },



            setRptList(data){
                this.rptList=data;
            },
            handleNodeClick(e,node,item) {
                this.currentNode=node.data;
                this.$emit('handleNodeClick', node.data);
                this.activeName="his";
            },
            hisNodeClick(e,node,item) {

                this.$emit('hisNodeClick', node.data);
            },
            selectHisNode(id){
                this.$nextTick(() => {
                    this.$refs.customTree2.setCurrentKey(id); // 设置id为的节点为选中状态
                    this.$emit('hisNodeClick', this.$refs.customTree2.getCurrentNode());

                });
            },
            scrollToNode() {


                this.$nextTick(()=>{    // 获取高亮节点
                    const tree = this.$refs.customTree2;
                      let highlightNode = tree.$el.querySelectorAll('.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content');
                         if(highlightNode && highlightNode.length){        highlightNode[0].scrollIntoView(50);
                         }});


            },




        }
    };


</script>

<style lang="scss" >


    .listlayout {
        height: 100%;
        width: 260px;
            /*flex: 1;*/
            position: relative;
             overflow: hidden;
        .el-tabs {
            width: 260px;
            height: calc(100%);
            border: 0px solid #267b87;
            .el-tabs__header {
                /*height: 36px;*/
                margin: 0;
                padding: 0px;
            }
            .el-tabs-card {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 34px;


            }

       }
            .el-tabs__item.is-active {
                color: #774917;
                background-color: #a9e0ea; //修改背景色
            }

            .el-tabs__content {
                margin: 0;
                padding: 0px;
                border: 0px solid #267b87;
                height: calc(100% - 36px);
                overflow: auto;
            }

        .parm_item
            {   padding: 0px 0px;
                margin: 0px;
                height: 32px;
                position: relative;
                float: left;
                width: 180px;
            }

    }
</style>
